module.exports = __webpack_public_path__ + "img/noI_leaf_sapphire.4689467d.png";